import monitorWifi from "../../../../../../assets/images/png-icons/telemont/monitor-wifi.png";
import planetConnected from "../../../../../../assets/images/png-icons/telemont/planet-connected.png";
import rope from "../../../../../../assets/images/png-icons/telemont/telemont-rope.png";
import userWeb from "../../../../../../assets/images/png-icons/telemont/user-web.png";
import wokerHat from "../../../../../../assets/images/png-icons/telemont/worker-hat.png";
import e2e from "../../../../../../assets/images/png-icons/telemont/e2e.png";
import GridTextCard from "./grid-text-card";
import styles from "./styles.module.css";

const OurNumbersGrid = () => {
  return (
    <div className={styles["our-numbers-grid"]}>
      <GridTextCard
        key={"helmet"}
        image={wokerHat}
        title={"51 anos"}
        description={"de história"}
      />
      {/* <GridTextCard
        key={"user-group"}
        image={userGroup}
        title={"+ de 10 mil"}
        description={"colaboradores"}
      /> */}
      <GridTextCard
        key={"rope"}
        image={rope}
        title={"54 mil"}
        description={
          <>
            Média mensal de
            <br />
            instalações de FTTH
          </>
        }
      />
      <GridTextCard
        key={"user-web"}
        image={userWeb}
        title={"2,2 milhões"}
        description={
          <>
            Acessos FTTH
            <br />
            (Voz + banda larga + TV)
          </>
        }
      />
      {/* <GridTextCard
        key={"home-wifi"}
        image={homeWifi}
        title={"1,15 milhões"}
        description={
          <>
            Construção de HPS <br />
            (Últimos 12 meses)
          </>
        }
      /> */}
      <GridTextCard
        key={"e2e"}
        image={e2e}
        title={"220 mil"}
        description={
          <>
            Km de fibra óptica
            <br />
            (manutenção)
          </>
        }
      />
      <GridTextCard
        key={"monitor-wifi"}
        image={monitorWifi}
        title={"58 mil"}
        description={"acessos de dados"}
      />
      <GridTextCard
        key={"planet-connected"}
        image={planetConnected}
        title={
          <>
            13 milhões (inspeção)
            <br />
            1,2 milhão (comercial)
          </>
        }
        description={
          <>
            unidades de consumidores
            <br />
            de energia
          </>
        }
        titleFontSize="24px"
      />
    </div>
  );
};

export default OurNumbersGrid;
